import { render } from "./EditMontant.vue?vue&type=template&id=27e30f3f&ts=true"
import script from "./EditMontant.vue?vue&type=script&lang=ts"
export * from "./EditMontant.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__